import { Card, Container, Row, Col, Image } from "react-bootstrap";
import Aot from "../assets/images/trendinganime/aot.png";
import Berserk from "../assets/images/trendinganime/berserk.jpg";
import Demons from "../assets/images/trendinganime/demonslayer.png";
import Jujutsu from "../assets/images/trendinganime/jujutsukaisen.png";
import Naruto from "../assets/images/trendinganime/narutogenin.png";
import VioletEG from "../assets/images/trendinganime/violeteverg.jpg";
import DragonBall from "../assets/images/trendinganime/dragonball.png";
import DeathNote from "../assets/images/trendinganime/deathnote.png";
import Onepiece from "../assets/images/trendinganime/onepiece.png";

const Trending = () => {
  return (
    <div>
      <Container>
        <h1 className="text-center pt-5 pb-3 text-yellow text-bold">
          TRENDING ANIME
        </h1>
        <Row>
          <Col md={4} className="movieWrapper" id="Trending">
            <Card className="text-white bg-dark movieImage">
              <Image src={Aot} alt="aot" className="images" />
              <Card.Title className=" text-center mt-2">
                Attack on Titan
              </Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Berserk} alt="Berserk" className="images" />
              <Card.Title className=" text-center mt-2">Berserk</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Jujutsu} alt="Jujutsu" className="images" />
              <Card.Title className=" text-center mt-2">
                Jujutsu Kaisen
              </Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Onepiece} alt="Onepiece" className="images" />
              <Card.Title className=" text-center mt-2">One Piece</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Naruto} alt="Naruto" className="images" />
              <Card.Title className=" text-center mt-2">
                Naruto Child
              </Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={DragonBall} alt="Dragon Ball" className="images" />
              <Card.Title className=" text-center mt-2">Dragon Ball</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={DeathNote} alt="Dragon Ball" className="images" />
              <Card.Title className=" text-center mt-2">Death Note</Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={Demons} alt="Demon Slayer" className="images" />
              <Card.Title className=" text-center mt-2">
                Demon Slayer
              </Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
          <Col md={4} className="movieWrapper">
            <Card className="text-white bg-dark movieImage">
              <Image src={VioletEG} alt="VioletEG" className="images" />
              <Card.Title className=" text-center mt-2">
                Violete Evergarden
              </Card.Title>
              <Card.Text className="text-left m-2 mt-1">
                This is a wider card with supporting text below as a natural
                lead-in to additional content.
              </Card.Text>
              <Card.Text className="text-left m-2">
                Last updated 3 mins ago
              </Card.Text>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Trending;
